export function initReveal() {
    const targets = document.querySelectorAll('[data-reveal]');
    if (!targets.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        targets.forEach((el) => el.setAttribute('data-revealed', 'true'));
        return;
    }

    const io = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.setAttribute('data-revealed', 'true');
                    io.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.15, rootMargin: '0px 0px -8% 0px' },
    );

    targets.forEach((el, i) => {
        if (!el.style.getPropertyValue('--reveal-delay')) {
            const idx = el.getAttribute('data-reveal-index');
            const delay = (idx !== null ? Number(idx) : i % 6) * 40;
            el.style.setProperty('--reveal-delay', `${delay}ms`);
        }
        io.observe(el);
    });
}
